// Shared rule for the one-shot primitives: fire when `trigger` becomes a new truthy value (including on mount).
// The effect re-runs only when the value changes, so re-renders never re-fire.
import { useEffect, useRef } from 'react';

export function useFire(trigger: unknown, fire: () => void | (() => void)) {
  const fn = useRef(fire); fn.current = fire;
  useEffect(() => {
    if (!trigger) return;
    const cleanup = fn.current();
    return () => { if (typeof cleanup === 'function') cleanup(); };
  }, [trigger]);
}
